import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { CyclistService } from 'src/app/services/cyclist.service';
import { HelpersService } from 'src/app/services/helpers.service';

@Component({
  selector: 'app-workshop-jobcard-add-booking-notes',
  templateUrl: './workshop-jobcard-add-booking-notes.component.html',
  styleUrls: ['./workshop-jobcard-add-booking-notes.component.scss']
})
export class WorkshopJobcardAddBookingNotesComponent {

  @Input() jobcard: any;
  @Output() jobcardChange = new EventEmitter<any>();

  public clientNotes: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private userService: UserService,
    private cyclistService: CyclistService,
    private helpersService: HelpersService
  ) { }

  ngOnInit() {
    this.clientNotes = this.jobcard.clientNotes || '';
  }

  addnotes() {
    this.jobcard.clientNotes = this.clientNotes;
    this.jobcardChange.emit({ ...this.jobcard });
    this.activeModal.close({ ...this.jobcard });
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.addnotes();
  }

}
